export default __webpack_public_path__ + "static/media/Aeonik-Regular.529cd03f.woff2";